import {ShiftEventCategory} from '@hconnect/common/types'

import {TasksFilterKey, TasksFilterKeyName} from '../consts'
import {SortOrder, TaskSource, TasksSortBy, TaskStatus} from '../types'

export const isTaskSource = (value: string | undefined): value is TaskSource =>
  Object.values(TaskSource).includes(value as TaskSource)

export const isShiftEventCategory = (value: string | undefined): value is ShiftEventCategory =>
  Object.values(ShiftEventCategory).includes(value as ShiftEventCategory)

export const isTaskStatus = (value: string | undefined): value is TaskStatus =>
  Object.values(TaskStatus).includes(value as TaskStatus)

export const isTasksFilterKey = (value: string | undefined): value is TasksFilterKeyName =>
  Object.values(TasksFilterKey).includes(value as TasksFilterKeyName)

export const isTasksSortBy = (value: string | undefined): value is TasksSortBy =>
  Object.values(TasksSortBy).includes(value as TasksSortBy)

export const isSortOrder = (value: string | undefined): value is SortOrder =>
  Object.values(SortOrder).includes(value as SortOrder)

export const isOnlyPomSourceSelected = (sourceFilters: TaskSource[]): boolean =>
  sourceFilters.length === 1 && sourceFilters[0] === TaskSource.EASY_POM

export const isPomSourceSelected = (sourceFilters: TaskSource[]): boolean =>
  sourceFilters.includes(TaskSource.EASY_POM)
